export default __webpack_public_path__ + "static/facebook-0ca2caf0d28667bd7a54c058745665a7.svg";